
import formatDateBasedTimezoneValue from "@/app/infrastructures/misc/common-library/FormatDateBasedTimezoneValue";
import { Vue, Options, prop } from "vue-class-component";
import { CargoV2HistoryItemCargoFlightsDetail } from "@/domain/entities/CargoV2";
import moment from "moment";

class Props {
  item = prop<any>({
    default: {},
    type: Object,
  });
  dateTime = prop<string>({
    default: "",
    type: String,
  });
  active = prop<boolean>({
    default: false,
    type: Boolean,
  });
  status = prop<string>({
    default: "",
    type: String,
  });
  transitLocation = prop<string>({
    default: "",
    type: String,
  });
  districtCity = prop<string>({
    default: "",
    type: String,
  });
  description = prop<string>({
    default: "",
    type: String,
  });
  tooltip = prop<string>({
    default: "",
    type: String,
  });
  isVerticalLine = prop<boolean>({
    default: false,
    type: Boolean,
  });
  isHalfVerticalLine = prop<boolean>({
    default: false,
    type: Boolean,
  });
  koli = prop<number>({
    default: 0,
    type: Number,
  });
  grossWeight = prop<number>({
    default: 0,
    type: Number,
  });
  volumeWeight = prop<number>({
    default: 0,
    type: Number,
  });
  flightCode = prop<string>({
    default: "",
    type: String,
  });
  flightDateTime = prop<string>({
    default: "",
    type: String,
  });
  departureFlightDate = prop<string>({
    default: "",
    type: String,
  });
  arrivalFlightDate = prop<string>({
    default: "",
    type: String,
  });
  totalTransit = prop<number>({
    default: 0,
    type: Number
  })
  cargoFlightDetails = prop<CargoV2HistoryItemCargoFlightsDetail[]>({
    default: [] as CargoV2HistoryItemCargoFlightsDetail[]
  })
}

@Options({
  name: "Timeline",
  emits: ["onClickValue"],
})
export default class extends Vue.with(Props) {
  isAccordionOpen = false;

  toggleAccordion() {
    this.isAccordionOpen = !this.isAccordionOpen;
  }

  get isFlightDeparted() {
    return this.status.toLowerCase() === "flight departed"
  }

  get isFlightArrived() {
    return this.status.toLowerCase() === "flight arrived"
  }

  formatTime(dateTime: string) {
    return formatDateBasedTimezoneValue(dateTime, "HH.mm", false);
  }

  formatFlightDateTime(dateTime: string) {
    return formatDateBasedTimezoneValue(dateTime, "DD MMM YYYY, HH:mm", false);
  }

  getFlightTime(dateTime: string) {
    return moment.parseZone(dateTime).format("HH:mm");
  }

  onClickValue() {
    this.$emit("onClickValue", this.item);
  }
}
